(function (Drupal) {
  'use strict';

  function cleanNumberFromText(text) {
    if (!text && text !== 0) return null;
    // Remove all characters except digits, dot, comma and minus.
    const cleaned = String(text).replace(/[^0-9,\.\-]/g, '');
    if (cleaned === '') return null;
    // If it contains dot as thousand separator, remove dots; if comma exists
    // treat comma as decimal separator and replace with dot for parseFloat.
    let normalized = cleaned;
    // If there are both '.' and ',', assume '.' are thousand separators.
    if (normalized.indexOf('.') !== -1 && normalized.indexOf(',') !== -1) {
      normalized = normalized.replace(/\./g, '');
      normalized = normalized.replace(/,/g, '.');
    }
    else if (normalized.indexOf('.') !== -1 && normalized.indexOf(',') === -1) {
      // If only dots present, remove them (they are thousands separators)
      normalized = normalized.replace(/\./g, '');
    }
    else if (normalized.indexOf(',') !== -1 && normalized.indexOf('.') === -1) {
      // Only comma present, treat as decimal separator
      normalized = normalized.replace(/,/g, '.');
    }

    const num = parseFloat(normalized);
    if (Number.isNaN(num)) return null;
    return num;
  }

  function formatCurrencyNoDecimals(num) {
    // Use Intl to format thousands with dot (de-DE style) and no decimals.
    try {
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(Math.round(num));
    }
    catch (e) {
      // Fallback: simple regex grouping
      const s = String(Math.round(num));
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function formatPriceElements(root) {
    root = root || document;
    // Selectors used in list and node templates
    const selectors = [
      '.views-field.views-field-field-precio-base .field-content',
      '.field--name-field-precio-base .field__item'
    ];
    selectors.forEach((sel) => {
      const els = root.querySelectorAll(sel);
      els.forEach((el) => {
        const text = el.textContent || el.innerText || '';
        // Skip if already contains $ and dots (assume already formatted)
        const maybeNum = cleanNumberFromText(text);
        if (maybeNum === null) return;
        const formatted = formatCurrencyNoDecimals(maybeNum);
        el.textContent = '$' + formatted;
      });
    });
  }

  Drupal.behaviors.secopPriceFormat = {
    attach: function (context) {
      // Run on initial attach, but limit scope to the provided context for efficiency
      const root = (context instanceof Document) ? document : context;
      formatPriceElements(root);

      // If jQuery AJAX updates Views, listen to ajaxComplete but debounce
      if (window.jQuery && window.jQuery(document)) {
        let ajaxTimer = null;
        window.jQuery(document).ajaxComplete(function () {
          if (ajaxTimer) clearTimeout(ajaxTimer);
          ajaxTimer = setTimeout(() => {
            const container = document.querySelector('.lista-contratos-secop');
            if (container) formatPriceElements(container);
          }, 250);
        });
      }

      // MutationObserver fallback: watch for added nodes under list container
      // but disconnect after the first stabilized update to avoid continuous work.
      const list = document.querySelector('.lista-contratos-secop');
      if (list) {
        let moTimer = null;
        const mo = new MutationObserver((mutations) => {
          let added = false;
          for (const m of mutations) {
            if (m.addedNodes && m.addedNodes.length) { added = true; break; }
          }
          if (added) {
            if (moTimer) clearTimeout(moTimer);
            moTimer = setTimeout(() => {
              formatPriceElements(list);
              // Disconnect observer to prevent repeated heavy work
              try { mo.disconnect(); } catch (e) { /* ignore */ }
            }, 200);
          }
        });
        mo.observe(list, { childList: true, subtree: true });
      }
    }
  };

})(Drupal);
